exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item[data-v-3f58dc34]{padding-left:30px;font-size:13px;font-family:PingFangSC-Regular, PingFang SC;font-weight:400;color:#303133;margin-bottom:20px}.tips[data-v-3f58dc34]{font-size:13px;font-family:PingFang SC-Regular, PingFang SC;font-weight:400;color:#909399;margin-left:20px}.from-item-title[data-v-3f58dc34]{border-left:3px solid #1890ff}.from-item-title span[data-v-3f58dc34]{padding-left:10px;font-weight:600;font-size:14px}.demo-ruleForm[data-v-3f58dc34]{margin:20px}\n", ""]);

// exports
